(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.querySelectorAll('[data-cart-quantity]').forEach((control) => {
    const input = control.querySelector('input');
    control.querySelector('[data-cart-minus]')?.addEventListener('click', () => {
      input.value = Math.max(0, Number(input.value) - 1);
    });
    control.querySelector('[data-cart-plus]')?.addEventListener('click', () => {
      input.value = Number(input.value) + 1;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.querySelectorAll('[data-sort-by]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const header = document.querySelector('.js-site-header');
  if (header) {
    const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 40);
    const menuToggle = header.querySelector('[data-menu-toggle]');
    const navigation = header.querySelector('[data-mobile-navigation]');
    const closeMenu = () => {
      header.classList.remove('menu-is-open');
      menuToggle?.setAttribute('aria-expanded', 'false');
      menuToggle?.setAttribute('aria-label', 'Open menu');
    };

    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });

    menuToggle?.addEventListener('click', () => {
      const isOpen = header.classList.toggle('menu-is-open');
      menuToggle.setAttribute('aria-expanded', String(isOpen));
      menuToggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
    });

    navigation?.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeMenu();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-cinematic"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-carousel]').forEach((carousel) => {
    const slides = [...carousel.querySelectorAll('[data-slide]')];
    const dots = [...carousel.querySelectorAll('[data-dot]')];
    const previous = carousel.querySelector('[data-previous]');
    const next = carousel.querySelector('[data-next]');
    const interval = Number(carousel.dataset.autoplay) || 6000;
    let current = 0;
    let timer;

    const showSlide = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === current));
    };

    const restart = () => {
      window.clearInterval(timer);
      if (slides.length > 1) timer = window.setInterval(() => showSlide(current + 1), interval);
    };

    previous?.addEventListener('click', () => {
      showSlide(current - 1);
      restart();
    });
    next?.addEventListener('click', () => {
      showSlide(current + 1);
      restart();
    });
    dots.forEach((dot) => dot.addEventListener('click', () => {
      showSlide(Number(dot.dataset.dot));
      restart();
    }));
    carousel.addEventListener('mouseenter', () => window.clearInterval(timer));
    carousel.addEventListener('mouseleave', restart);
    restart();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.querySelectorAll('[data-product-section]').forEach((section) => {
const mainImage = section.querySelector('[data-gallery-main]');
const thumbnails = [...section.querySelectorAll('[data-gallery-thumb]')];
const quantity = section.querySelector('[data-quantity]');
const variantSelect = section.querySelector('[data-variant-select]');
const price = section.querySelector('[data-product-price]');
const addButton = section.querySelector('[data-add-to-cart]');

thumbnails.forEach((thumbnail) => {
thumbnail.addEventListener('click', () => {
mainImage.src = thumbnail.dataset.imageSrc;
mainImage.alt = thumbnail.dataset.imageAlt;
thumbnails.forEach((item) => item.classList.remove('is-active'));
thumbnail.classList.add('is-active');
});
});

section.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
quantity.value = Math.max(1, Number(quantity.value) - 1);
});
section.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
quantity.value = Number(quantity.value) + 1;
});

variantSelect?.addEventListener('change', () => {
const option = variantSelect.selectedOptions[0];
const compare = option.dataset.comparePrice;
price.innerHTML = `<span>${option.dataset.price}</span>${compare ? `<s>${compare}</s>` : ''}`;
const available = option.dataset.available === 'true';
addButton.disabled = !available;
addButton.textContent = available ? 'Add to cart' : 'Sold out';
const mediaThumb = thumbnails.find((thumb) => thumb.dataset.mediaId === option.dataset.mediaId);
mediaThumb?.click();
});

const modal = document.getElementById('size-chart-modal');
section.querySelector('[data-modal-open="size-chart-modal"]')?.addEventListener('click', () => {
if (modal) modal.setAttribute('aria-hidden', 'false');
});
modal?.querySelectorAll('[data-modal-close]').forEach(btn => {
btn.addEventListener('click', () => {
modal.setAttribute('aria-hidden', 'true');
});
});
});

  } catch(e) { console.error(e); }
})();
})();
